<script setup>
// Confirmação do SISTEMA no lugar do confirm() do navegador (que abre a caixa
// crua "app.chatsuite.com.br diz"). Abre o Dialog padrão e devolve uma
// Promise<boolean>: `if (!(await confirmRef.value.ask({ ... }))) return;`
import { ref } from 'vue';
import Dialog from './Dialog.vue';

const dialogRef = ref(null);
const opts = ref({
  title: '',
  description: '',
  confirmLabel: '',
  cancelLabel: '',
  type: 'alert',
});
let resolver = null;

const settle = value => {
  if (!resolver) return;
  const done = resolver;
  resolver = null;
  done(value);
};

// Abre com as opções e resolve true (confirmou) ou false (cancelou/fechou).
const ask = options => {
  settle(false);
  opts.value = { ...opts.value, type: 'alert', ...options };
  return new Promise(resolve => {
    resolver = resolve;
    dialogRef.value?.open();
  });
};

const onConfirm = () => {
  settle(true);
  dialogRef.value?.close();
};
// Fechar por Esc/clique fora/cancelar = não confirmou.
const onClose = () => settle(false);

defineExpose({ ask });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :type="opts.type"
    :title="opts.title"
    :description="opts.description"
    :confirm-button-label="opts.confirmLabel"
    :cancel-button-label="opts.cancelLabel"
    width="md"
    @confirm="onConfirm"
    @close="onClose"
  />
</template>
